import React from 'react';
import styles from './HowDoesItWork.module.css';
import videoFile from '../../assets/video/HowDoesItWork.mp4';
import previewImage from '../../assets/img/preview_HowDoesItWork.webp';

export default function HowDoesItWork() {
  return (
    <section id="3" className={styles.container}>
      <div className={styles.title}>Як це працює?</div>
      <div className={styles.video_container}>
        <video controls poster={previewImage}>
          <source src={videoFile} type="video/mp4" />
          Ваш браузер не підтримує відео.
        </video>
      </div>
    </section>
  );
}
